import { Outlet } from 'react-router';
import { UserNotActive } from '../../_pages/UserNotActive';
import { useConfigValuesState } from '../../hooks/useConfigValue';

export const UserActiveRoute = ({ children }: { children?: React.ReactNode }) => {
    const {
        initialData: {
            aggregatedUser: { user },
        },
    } = useConfigValuesState();

    if (user?.isNotActive) {
        return <UserNotActive />;
    }

    return children ? <>{children}</> : <Outlet />;
};
